import React from "react";
import styles from "./FloatingWhatsApp.module.css";

const FloatingWhatsApp = () => {
  return (
    <a
      href="https://wa.me/254722265791?text=Hello,%20I%20would%20like%20an%20online%20consultation"
      className={styles.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
      />
    </a>
  );
};

export default FloatingWhatsApp;
